<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('roles.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/role'"
        :params="filter"
        :createBtnLabel="$t('roles.create')"
        createRouteName="administration.roleCreate"
        :excelFields="excelFields"
        excelName="roles"
        :downloadSampleStatus="true"
        downloadSampleUrl="role/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="role/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { API_BASE_URL_SSO } from "../../../../config/constant";
import { core } from "../../../../config/pluginInit";
import RoleFilter from "../models/RoleFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      API_BASE_URL_SSO,
      filter: new RoleFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("roles.name"), sortable: true },
        {
          key: "created_at",
          label: this.$t("table.createdAt"),
          type: "dateTime",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "administration.roleView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "administration.roleUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("roles.item"),
              textContent: "name",
              url: "admin/role",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  mounted() {
    core.index();
  },
};
</script>
